import React from 'react';
import Image from 'next/image';

import { Section, CTA } from 'react-scale/components';

import styles from './TopSection.module.css';

const TopSection = ({ title, subtitle }) => (
  <Section container={false} size="lg">
    <div className="container">
      <div className={styles.mainGrid}>
        <div className="relative w-20 h-20 mx-auto md:w-28 lg:w-32 md:h-28 lg:h-32">
          <Image
            src="/static/images/pages/careers/scale-growing.svg"
            alt="the amazing Scale Team!"
            layout="fill"
            quality="100"
          />
        </div>
        <div className="flex flex-col flex-wrap items-center justify-center lg:flex-row md:items-start lg:items-center md:justify-between">
          <header className="text-center md:text-left">
            <h1
              className="mb-2 text-4xl text-black capitalize font-aeonik md:text-5xl lg:mb-4"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <p className="mb-8 text-lg text-neutral-800 md:text-xl">{subtitle}</p>
            <div className="flex justify-center md:justify-start">
              <CTA
                theme="light"
                cta={{
                  buttons: [
                    {
                      href: '#jobs',
                      text: 'View Open Positions',
                      type: 'primary'
                    }
                  ]
                }}
              />
            </div>
          </header>
        </div>
      </div>
    </div>
  </Section>
);

export default TopSection;
